import * as i0 from '@angular/core';
import { Component, Injectable, ViewContainerRef, ViewChild, Input, EventEmitter, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule, DatePipe, CurrencyPipe } from '@angular/common';
import * as i2 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import * as i3 from '@ng-select/ng-select';
import { NgSelectModule } from '@ng-select/ng-select';
import * as i3$1 from 'angular-mydatepicker';
import { CalAnimation, AngularMyDatePickerModule } from 'angular-mydatepicker';
import * as jp from 'jsonpath';
import * as i2$1 from 'ng-svg-icon-sprite';
import { IconSpriteModule } from 'ng-svg-icon-sprite';
import { Subscription, finalize, filter } from 'rxjs';
import { Events } from 'ag-grid-enterprise';
import * as i1$1 from '@angular/router';
import { NavigationStart } from '@angular/router';
import { AgGridModule } from 'ag-grid-angular';
export { AgGridAngular, AgGridModule } from 'ag-grid-angular';

function isNotNullOrEmpty(stringToCheck) {
    let isUndefined = stringToCheck === undefined;
    let isNull = stringToCheck === null;
    if (!isUndefined && !isNull)
        stringToCheck = stringToCheck.toString().trim();
    let isEmpty = stringToCheck === '';
    return !isUndefined && !isNull && !isEmpty;
}

class BooleanEditorComponent {
    constructor() {
        this.selectValues = [];
        this.cellWidth = "";
        this.cellHeight = "";
    }
    agInit(params) {
        this.params = params;
        this.useCheckbox = this.params.displayAsCheckBox;
        this.setInitialState(this.params);
        this.cellWidth = params.column.getActualWidth() + 'px';
        this.cellHeight = params.node.rowHeight + 'px';
    }
    setInitialState(params) {
        this.value = params.value;
        this.selectValues.push({ value: false, displayName: isNotNullOrEmpty(params.falseValueDisplayFormat) ? params.falseValueDisplayFormat : "False" });
        this.selectValues.push({ value: true, displayName: isNotNullOrEmpty(params.trueValueDisplayFormat) ? params.trueValueDisplayFormat : "True" });
    }
    getValue() {
        return this.value;
    }
}
BooleanEditorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: BooleanEditorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
BooleanEditorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: BooleanEditorComponent, selector: "boolean-cell", ngImport: i0, template: "<div *ngIf=\"useCheckbox\">\r\n  <input type='checkbox' [(ngModel)]=\"value\" />\r\n</div>\r\n<div *ngIf=\"!useCheckbox\">\r\n  <ng-select class=\"ag-grid\" [(ngModel)]=\"value\" [items]=\"selectValues\" [multiple]=\"false\" bindValue=\"value\" bindLabel=\"displayName\" [style.height]=\"cellHeight\" [style.width]=\"cellWidth\"></ng-select>\r\n</div>\r\n", styles: [".ng-select.ng-select-single .ng-select-container{height:auto}.ng-select.ng-select-single .ng-select-container .ng-value-container .ng-input{top:0}.ng-select.ng-select-multiple .ng-select-container{height:auto}.ng-select.ng-select-multiple .ng-select-container .ng-value-container{padding:0;min-height:22px;gap:.25rem;display:flex;flex-wrap:wrap}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value.ng-star-inserted{margin:0 0 0 .1rem;display:flex}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon{padding:1px 3px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-placeholder{position:static;margin-left:.5rem}.ng-select .ng-select-container{border-color:#858585;border-radius:0;min-height:25px;height:auto}.ng-select .ng-select-container .ng-arrow{border-color:#858585 transparent transparent}.ng-select .ng-select-container .ng-clear-wrapper{width:auto}.ng-select .ng-select-container .ng-value-container .ng-placeholder,.ng-select span{font-size:.9rem;line-height:.9rem}ng-select.ag-grid{display:flex;align-items:center;margin:0 .15rem;height:40px!important}ng-select.ag-grid.ng-select-focused .ng-select-container{outline:solid 1px #000}ng-select.ag-grid.ng-select-single .ng-select-container{height:36px;border-color:#767676;border-radius:2px}ng-select.ag-grid.ng-select-single.ng-select-opened .ng-dropdown-panel .scroll-host{border-color:#000}ng-select.ag-grid.ng-select-single.ng-select-opened .ng-select-container{border-color:#000}ng-select.ag-grid.ng-select-single.ng-select-opened .ng-select-container .ng-arrow{border-color:transparent transparent #000!important}ng-select.ag-grid .ng-value,ng-select.ag-grid .ng-clear{color:#000}ng-select.ag-grid .ng-arrow{border-color:#000 transparent transparent!important}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i3.NgSelectComponent, selector: "ng-select", inputs: ["bindLabel", "bindValue", "markFirst", "placeholder", "notFoundText", "typeToSearchText", "addTagText", "loadingText", "clearAllText", "appearance", "dropdownPosition", "appendTo", "loading", "closeOnSelect", "hideSelected", "selectOnTab", "openOnEnter", "maxSelectedItems", "groupBy", "groupValue", "bufferAmount", "virtualScroll", "selectableGroup", "selectableGroupAsModel", "searchFn", "trackByFn", "clearOnBackspace", "labelForId", "inputAttrs", "tabIndex", "readonly", "searchWhileComposing", "minTermLength", "editableSearchTerm", "keyDownFn", "typeahead", "multiple", "addTag", "searchable", "clearable", "isOpen", "items", "compareWith", "clearSearchOnAdd"], outputs: ["blur", "focus", "change", "open", "close", "search", "clear", "add", "remove", "scroll", "scrollToEnd"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: BooleanEditorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'boolean-cell', template: "<div *ngIf=\"useCheckbox\">\r\n  <input type='checkbox' [(ngModel)]=\"value\" />\r\n</div>\r\n<div *ngIf=\"!useCheckbox\">\r\n  <ng-select class=\"ag-grid\" [(ngModel)]=\"value\" [items]=\"selectValues\" [multiple]=\"false\" bindValue=\"value\" bindLabel=\"displayName\" [style.height]=\"cellHeight\" [style.width]=\"cellWidth\"></ng-select>\r\n</div>\r\n", styles: [".ng-select.ng-select-single .ng-select-container{height:auto}.ng-select.ng-select-single .ng-select-container .ng-value-container .ng-input{top:0}.ng-select.ng-select-multiple .ng-select-container{height:auto}.ng-select.ng-select-multiple .ng-select-container .ng-value-container{padding:0;min-height:22px;gap:.25rem;display:flex;flex-wrap:wrap}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value.ng-star-inserted{margin:0 0 0 .1rem;display:flex}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon{padding:1px 3px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-placeholder{position:static;margin-left:.5rem}.ng-select .ng-select-container{border-color:#858585;border-radius:0;min-height:25px;height:auto}.ng-select .ng-select-container .ng-arrow{border-color:#858585 transparent transparent}.ng-select .ng-select-container .ng-clear-wrapper{width:auto}.ng-select .ng-select-container .ng-value-container .ng-placeholder,.ng-select span{font-size:.9rem;line-height:.9rem}ng-select.ag-grid{display:flex;align-items:center;margin:0 .15rem;height:40px!important}ng-select.ag-grid.ng-select-focused .ng-select-container{outline:solid 1px #000}ng-select.ag-grid.ng-select-single .ng-select-container{height:36px;border-color:#767676;border-radius:2px}ng-select.ag-grid.ng-select-single.ng-select-opened .ng-dropdown-panel .scroll-host{border-color:#000}ng-select.ag-grid.ng-select-single.ng-select-opened .ng-select-container{border-color:#000}ng-select.ag-grid.ng-select-single.ng-select-opened .ng-select-container .ng-arrow{border-color:transparent transparent #000!important}ng-select.ag-grid .ng-value,ng-select.ag-grid .ng-clear{color:#000}ng-select.ag-grid .ng-arrow{border-color:#000 transparent transparent!important}\n"] }]
        }] });

class DatePickerHelperService {
    constructor(datePipe) {
        this.datePipe = datePipe;
        this.currentDate = new Date();
        this.defaultDatePickerOptions = {
            dateFormat: 'mm/dd/yyyy',
            calendarAnimation: { in: CalAnimation.ScaleTop, out: CalAnimation.ScaleTop },
            appendSelectorToBody: true,
            firstDayOfWeek: 'mo',
            sunHighlight: true,
            markCurrentDay: true,
            alignSelectorRight: false,
            openSelectorTopOfInput: false,
            monthSelector: true,
            yearSelector: true,
            minYear: 2010,
            maxYear: 2200,
            showSelectorArrow: true,
            showWeekNumbers: false,
            markDates: [],
            satHighlight: false,
            highlightDates: [],
            monthLabels: {
                1: 'January',
                2: 'February',
                3: 'March',
                4: 'April',
                5: 'May',
                6: 'June',
                7: 'July',
                8: 'August',
                9: 'September',
                10: 'October',
                11: 'November',
                12: 'December'
            },
            disableWeekdays: [],
        };
    }
    convertIMyDateToDate(datePickerMyDate) {
        if (datePickerMyDate == null)
            return null;
        if (datePickerMyDate.year === 0 && datePickerMyDate.day === 0 && datePickerMyDate.month === 0)
            return null;
        const year = datePickerMyDate.year;
        const day = datePickerMyDate.day;
        const month = (datePickerMyDate.month - 1);
        return new Date(year, month, day);
    }
    convertIMyDateModelToDate(datePickerModel) {
        if (datePickerModel == null || datePickerModel.singleDate == null)
            return null;
        if (datePickerModel.singleDate.date.year === 0 && datePickerModel.singleDate.date.day === 0 && datePickerModel.singleDate.date.month === 0)
            return null;
        return this.convertIMyDateToDate(datePickerModel.singleDate.date);
    }
    convertIMyDateModelToIMyDate(datePickerModel) {
        if (datePickerModel == null || datePickerModel.singleDate == null)
            return null;
        if (datePickerModel.singleDate.date.year === 0 && datePickerModel.singleDate.date.day === 0 && datePickerModel.singleDate.date.month === 0)
            return null;
        return datePickerModel.singleDate.date;
    }
    convertDateToIMyDate(date = new Date()) {
        let myDate = {
            year: date.getFullYear(),
            month: parseInt(this.getPaddedDateValue(date.getMonth() + 1)),
            day: parseInt(this.getPaddedDateValue(date.getDate())),
            jsDate: date,
            formatted: this.datePipe.transform(date, DatePickerHelperService.DateFormat),
            epoc: null
        };
        return myDate;
    }
    convertDateToIMyDateModel(date = new Date()) {
        if (date != null) {
            let dateClass = new Date(date);
            return {
                isRange: false,
                singleDate: this.convertDateToIMyDate(dateClass),
            };
        }
        else {
            let currentDate = new Date();
            return {
                isRange: false,
                singleDate: this.convertDateToIMyDate(currentDate),
            };
        }
    }
    getPaddedDateValue(dateNumber) {
        if (dateNumber.toString().length > 1) {
            return dateNumber.toString();
        }
        return ("0" + dateNumber.toString().slice(-2));
    }
    getYearMonthAndDayOffset(yearOffset, monthOffset, dayOffset) {
        //Account for the day
        const tempDate = new Date(this.currentDate.toUTCString());
        tempDate.setTime(tempDate.getTime() + (dayOffset * 86400000));
        tempDate.setUTCFullYear(tempDate.getUTCFullYear() + yearOffset);
        tempDate.setUTCMonth(tempDate.getUTCMonth() + monthOffset);
        return {
            year: tempDate.getFullYear(),
            month: tempDate.getMonth(),
            day: tempDate.getDate()
        };
    }
    generateIMyDateWithOffset(yearOffset = 0, monthOffset = 0, dayOffset = 0) {
        const dateValues = this.getDateValuesFromOffset(yearOffset, monthOffset, dayOffset);
        return {
            year: dateValues.year,
            month: dateValues.month + 1,
            day: dateValues.day
        };
    }
    generateIMyDateModelWithOffset(yearOffset = 0, monthOffset = 0, dayOffset = 0) {
        const dateValues = this.getDateValuesFromOffset(yearOffset, monthOffset, dayOffset);
        let correspondingIMyDate = {
            year: dateValues.year,
            month: dateValues.month + 1,
            day: dateValues.day
        };
        return {
            isRange: false,
            singleDate: {
                date: correspondingIMyDate,
                jsDate: this.convertIMyDateToDate(correspondingIMyDate),
                formatted: this.datePipe.transform(this.convertIMyDateToDate(correspondingIMyDate), DatePickerHelperService.DateFormat),
                epoc: null
            }
        };
    }
    generateIMyDateModelWithIMyDate(myDate, mySecondDate = null) {
        if (mySecondDate == null)
            return {
                isRange: false,
                singleDate: {
                    date: myDate,
                    jsDate: this.convertIMyDateToDate(myDate),
                    formatted: this.datePipe.transform(this.convertIMyDateToDate(myDate), DatePickerHelperService.DateFormat),
                    epoc: null
                }
            };
        else
            return {
                isRange: true,
                dateRange: {
                    beginDate: myDate,
                    beginJsDate: this.convertIMyDateToDate(myDate),
                    beginEpoc: null,
                    endDate: mySecondDate,
                    endJsDate: this.convertIMyDateToDate(mySecondDate),
                    endEpoc: null,
                    formatted: this.datePipe.transform(this.convertIMyDateToDate(myDate)) + '-' + this.datePipe.transform(this.convertIMyDateToDate(mySecondDate))
                }
            };
    }
    getNextWeekdayIncludingToday(date = new Date()) {
        let newDate = new Date(date);
        while (newDate.getDay() % 6 === 0) {
            newDate.setDate(newDate.getDate() + 1);
        }
        return newDate;
    }
    getDateValuesFromOffset(yearOffset, monthOffset, dayOffset) {
        const monthAndYear = this.getYearMonthAndDayOffset(yearOffset, monthOffset, dayOffset);
        return {
            year: monthAndYear.year,
            month: monthAndYear.month,
            day: monthAndYear.day
        };
    }
}
DatePickerHelperService.DateFormat = 'MM/dd/yyyy';
DatePickerHelperService.DatePickerFormat = 'mm/dd/yyyy';
DatePickerHelperService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DatePickerHelperService, deps: [{ token: i1.DatePipe }], target: i0.ɵɵFactoryTarget.Injectable });
DatePickerHelperService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DatePickerHelperService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DatePickerHelperService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.DatePipe }]; } });

class DatePickerEditorComponent {
    constructor(dateHelperService) {
        this.dateHelperService = dateHelperService;
        this.cellWidth = "";
        this.cellHeight = "";
    }
    // gets called once before the renderer is used
    agInit(params) {
        //initialize to our defaults if nothing else is provided
        if (params.value === null || params.value === undefined)
            params.datePickerOptions = this.dateHelperService.defaultDatePickerOptions;
        this.myDatePickerOptions = params.datePickerOptions;
        if (params.data !== null || params.data !== undefined && params.value instanceof Date)
            this.dateModel = this.dateHelperService.convertDateToIMyDateModel(params.value);
        this.cellWidth = (params.column.getActualWidth() - 10) + 'px';
        this.cellHeight = (params.node.rowHeight - 5) + 'px';
    }
    // returns the new value after editing
    getValue() {
        return this.dateModel.singleDate.jsDate;
        //return null;
    }
}
DatePickerEditorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DatePickerEditorComponent, deps: [{ token: DatePickerHelperService }], target: i0.ɵɵFactoryTarget.Component });
DatePickerEditorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: DatePickerEditorComponent, selector: "date-picker-cell", ngImport: i0, template: "<input input class=\"input-box\" placeholder=\"Date\"\r\n       angular-mydatepicker name=\"editedDate\"\r\n       [(ngModel)]=\"dateModel\" [options]=\"myDatePickerOptions\"\r\n       (click)=\"dateEditor.toggleCalendar()\"\r\n       #dateEditor=\"angular-mydatepicker\" [style.height]=\"cellHeight\" [style.width]=\"cellWidth\"/>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i3$1.AngularMyDatePickerDirective, selector: "[angular-mydatepicker]", inputs: ["defaultMonth", "options", "locale"], outputs: ["dateChanged", "inputFieldChanged", "calendarViewChanged", "calendarToggle", "rangeDateSelection", "viewActivated"], exportAs: ["angular-mydatepicker"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DatePickerEditorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'date-picker-cell', template: "<input input class=\"input-box\" placeholder=\"Date\"\r\n       angular-mydatepicker name=\"editedDate\"\r\n       [(ngModel)]=\"dateModel\" [options]=\"myDatePickerOptions\"\r\n       (click)=\"dateEditor.toggleCalendar()\"\r\n       #dateEditor=\"angular-mydatepicker\" [style.height]=\"cellHeight\" [style.width]=\"cellWidth\"/>\r\n" }]
        }], ctorParameters: function () { return [{ type: DatePickerHelperService }]; } });

class NgSelectEditorComponent {
    constructor() {
        this.isMultiSelect = false;
        this.bindLabel = "";
        this.bindValue = "";
        this.placeholder = "";
        this.cellWidth = "";
        this.cellHeight = "";
        this.useBindValue = false;
    }
    agInit(params) {
        this.params = params;
        this.isMultiSelect = params.isMultiSelect;
        this.bindLabel = params.bindLabel;
        this.bindValue = params.bindValue;
        this.placeholder = params.placeholder;
        this.itemChangedHandler = params.itemChangedEventHandler;
        this.useBindValue = isNotNullOrEmpty(params.bindValue);
        this.options = params.options;
        this.setInitialState(this.params);
        this.cellWidth = params.column.getActualWidth() + 'px';
        this.cellHeight = params.node.rowHeight + 'px';
    }
    setInitialState(params) {
        this.value = params.value;
    }
    getValue() {
        return this.value;
    }
    onNgModelChanged(event) {
        if (this.itemChangedHandler != null && this.itemChangedHandler != undefined)
            this.itemChangedHandler(event, this.params);
    }
}
NgSelectEditorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NgSelectEditorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
NgSelectEditorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: NgSelectEditorComponent, selector: "ng-select-cell", ngImport: i0, template: "<ng-select *ngIf=\"useBindValue\" class=\"ag-grid\" [(ngModel)]=\"value\" (ngModelChange)=\"onNgModelChanged($event)\" [items]=\"options\" [placeholder]=\"placeholder\" [multiple]=\"isMultiSelect\" [bindValue]=\"bindValue\" [bindLabel]=\"bindLabel\" [style.height]=\"cellHeight\" [style.width]=\"cellWidth\"></ng-select>\r\n<ng-select *ngIf=\"!useBindValue\" class=\"ag-grid\" [(ngModel)]=\"value\" (ngModelChange)=\"onNgModelChanged($event)\" [items]=\"options\" [placeholder]=\"placeholder\" [multiple]=\"isMultiSelect\" [bindLabel]=\"bindLabel\" [style.height]=\"cellHeight\" [style.width]=\"cellWidth\"></ng-select>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i3.NgSelectComponent, selector: "ng-select", inputs: ["bindLabel", "bindValue", "markFirst", "placeholder", "notFoundText", "typeToSearchText", "addTagText", "loadingText", "clearAllText", "appearance", "dropdownPosition", "appendTo", "loading", "closeOnSelect", "hideSelected", "selectOnTab", "openOnEnter", "maxSelectedItems", "groupBy", "groupValue", "bufferAmount", "virtualScroll", "selectableGroup", "selectableGroupAsModel", "searchFn", "trackByFn", "clearOnBackspace", "labelForId", "inputAttrs", "tabIndex", "readonly", "searchWhileComposing", "minTermLength", "editableSearchTerm", "keyDownFn", "typeahead", "multiple", "addTag", "searchable", "clearable", "isOpen", "items", "compareWith", "clearSearchOnAdd"], outputs: ["blur", "focus", "change", "open", "close", "search", "clear", "add", "remove", "scroll", "scrollToEnd"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NgSelectEditorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ng-select-cell', template: "<ng-select *ngIf=\"useBindValue\" class=\"ag-grid\" [(ngModel)]=\"value\" (ngModelChange)=\"onNgModelChanged($event)\" [items]=\"options\" [placeholder]=\"placeholder\" [multiple]=\"isMultiSelect\" [bindValue]=\"bindValue\" [bindLabel]=\"bindLabel\" [style.height]=\"cellHeight\" [style.width]=\"cellWidth\"></ng-select>\r\n<ng-select *ngIf=\"!useBindValue\" class=\"ag-grid\" [(ngModel)]=\"value\" (ngModelChange)=\"onNgModelChanged($event)\" [items]=\"options\" [placeholder]=\"placeholder\" [multiple]=\"isMultiSelect\" [bindLabel]=\"bindLabel\" [style.height]=\"cellHeight\" [style.width]=\"cellWidth\"></ng-select>\r\n" }]
        }] });

class NumericEditorComponent {
    constructor() {
        this.cellWidth = "";
        this.cellHeight = "";
    }
    agInit(params) {
        this.params = params;
        this.setInitialState(this.params);
        this.cellWidth = (params.column.getActualWidth() - 11) + 'px';
        this.cellHeight = (params.node.rowHeight - 5) + 'px';
    }
    setInitialState(params) {
        this.value = params.value;
    }
    getValue() {
        return this.value;
    }
    focusOut() {
    }
    ;
}
NumericEditorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NumericEditorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
NumericEditorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: NumericEditorComponent, selector: "numeric-cell", ngImport: i0, template: "<input type=\"number\" [(ngModel)]=\"value\"  [style.height]=\"cellHeight\" [style.width]=\"cellWidth\"/>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NumberValueAccessor, selector: "input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NumericEditorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'numeric-cell', template: "<input type=\"number\" [(ngModel)]=\"value\"  [style.height]=\"cellHeight\" [style.width]=\"cellWidth\"/>\r\n" }]
        }] });

class AgGridBooleanFilterComponent {
    constructor() {
        this.showTrueValues = true;
        this.showFalseValues = true;
    }
    agInit(params) {
        //Defaults these values if not set
        if (params.falseValueDisplayFormat == null || params.falseValueDisplayFormat == undefined)
            params.falseValueDisplayFormat = "No";
        if (params.trueValueDisplayFormat == null || params.trueValueDisplayFormat == undefined)
            params.trueValueDisplayFormat = "Yes";
        //So far we're only using this in issues widget, which is server side, and we plan to make all our widgets server side eventually, so default this to true
        if (params.isInServerSideFilterMode == null || params.trueValueDisplayFormat == undefined)
            params.isInServerSideFilterMode = true;
        this.params = params;
        this.valueGetter = params.valueGetter;
    }
    isFilterActive() {
        return !(this.showTrueValues && this.showFalseValues);
    }
    doesFilterPass(params) {
        //We don't worry about passing when in server side mode, because all results will have
        //have been filtered down to what we need already
        if (this.params.isInServerSideFilterMode)
            return true;
        else {
            let nodeValue = null;
            if (this.params.fieldPath)
                nodeValue = this.tryGetValue(params.node.data, this.params.fieldPath);
            else {
                nodeValue = this.valueGetter(params.node);
            }
            // if we don't want to show either true or false, only return true if value is unset
            if (!this.showTrueValues && !this.showFalseValues)
                return (nodeValue == null || nodeValue == undefined);
            else {
                return (this.showTrueValues && nodeValue == true) || (this.showFalseValues && nodeValue == false);
            }
        }
    }
    getModel() {
        var builtFilter = null;
        if (this.isFilterActive()) {
            builtFilter = {
                filterType: "boolean",
                type: "equals"
            };
            if (!this.showTrueValues && !this.showFalseValues)
                builtFilter.filter = null;
            else
                builtFilter.filter = this.showTrueValues;
        }
        return builtFilter;
    }
    setModel(model) {
        if (!model) {
            this.showFalseValues = true;
            this.showTrueValues = true;
        }
        else if (model.filter == null || model.filter == undefined) {
            this.showFalseValues = false;
            this.showTrueValues = false;
        }
        else {
            this.showFalseValues = !model.filter;
            this.showTrueValues = model.filter;
        }
    }
    ngAfterViewInit(params) {
        window.setTimeout(() => {
            this.checkboxContainer.element.nativeElement.focus();
        });
    }
    onSelectAllChange(newValue) {
        this.showFalseValues = newValue.target.checked;
        this.showTrueValues = newValue.target.checked;
        this.params.filterChangedCallback();
    }
    onShowTrueChange(newValue) {
        this.showTrueValues = newValue.target.checked;
        this.params.filterChangedCallback();
    }
    onShowFalseChange(newValue) {
        this.showFalseValues = newValue.target.checked;
        this.params.filterChangedCallback();
    }
    tryGetValue(data, path) {
        let value = "";
        try {
            value = jp.value(data, path);
        }
        catch (error) {
            console.error(error);
        }
        return value;
    }
}
AgGridBooleanFilterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AgGridBooleanFilterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AgGridBooleanFilterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: AgGridBooleanFilterComponent, selector: "filter-cell", viewQueries: [{ propertyName: "checkboxContainer", first: true, predicate: ["container"], descendants: true, read: ViewContainerRef, static: true }, { propertyName: "trueCheckbox", first: true, predicate: ["trueCheckbox"], descendants: true, read: ViewContainerRef, static: true }, { propertyName: "falseCheckbox", first: true, predicate: ["falseCheckbox"], descendants: true, read: ViewContainerRef, static: true }], ngImport: i0, template: "<div #container class=\"container\">\r\n    Boolean Filter:\r\n    <br>\r\n\r\n    <div class=\"checkbox-ag-grid\">\r\n        <label class=\"inline\">\r\n            <input #trueCheckbox type=\"checkbox\" [checked]=\"showTrueValues && showFalseValues\" (change)=\"onSelectAllChange($event)\">\r\n            <span class=\"checkbox-ag-grid-label\">Select All</span>\r\n        </label>\r\n    </div>\r\n    <hr />\r\n    <div class=\"checkbox-ag-grid\">\r\n        <label class=\"inline\">\r\n            <input #trueCheckbox type=\"checkbox\" [checked]=\"showTrueValues\" (change)=\"onShowTrueChange($event)\">\r\n            <span class=\"checkbox-ag-grid-label\">{{params.trueValueDisplayFormat}}</span>\r\n        </label>\r\n    </div>\r\n    <div class=\"checkbox-ag-grid\">\r\n        <label class=\"inline\">\r\n            <input #falseCheckbox type=\"checkbox\" [checked]=\"showFalseValues\" (change)=\"onShowFalseChange($event)\">\r\n            <span class=\"checkbox-ag-grid-label\">{{params.falseValueDisplayFormat}}</span>\r\n        </label>\r\n    </div>\r\n</div>\r\n\r\n", styles: ["@charset \"UTF-8\";.container{padding:.25rem}hr{margin:.25rem}.checkbox-ag-grid label{position:relative;display:flex}.checkbox-ag-grid label input{display:none}.checkbox-ag-grid label input:checked+.checkbox-ag-grid-label:after{content:\"\\2713\";display:inline-block;color:#0091ea;font-size:13px;position:absolute;left:2px;top:-2px}.checkbox-ag-grid label .checkbox-ag-grid-label{display:flex;align-items:center;font-size:12px}.checkbox-ag-grid label .checkbox-ag-grid-label:before{content:\"\";display:inline-block;color:#0091ea;height:15px;width:15px;border:solid 1px #0091ea;border-radius:3px;margin-right:.5rem}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AgGridBooleanFilterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'filter-cell', template: "<div #container class=\"container\">\r\n    Boolean Filter:\r\n    <br>\r\n\r\n    <div class=\"checkbox-ag-grid\">\r\n        <label class=\"inline\">\r\n            <input #trueCheckbox type=\"checkbox\" [checked]=\"showTrueValues && showFalseValues\" (change)=\"onSelectAllChange($event)\">\r\n            <span class=\"checkbox-ag-grid-label\">Select All</span>\r\n        </label>\r\n    </div>\r\n    <hr />\r\n    <div class=\"checkbox-ag-grid\">\r\n        <label class=\"inline\">\r\n            <input #trueCheckbox type=\"checkbox\" [checked]=\"showTrueValues\" (change)=\"onShowTrueChange($event)\">\r\n            <span class=\"checkbox-ag-grid-label\">{{params.trueValueDisplayFormat}}</span>\r\n        </label>\r\n    </div>\r\n    <div class=\"checkbox-ag-grid\">\r\n        <label class=\"inline\">\r\n            <input #falseCheckbox type=\"checkbox\" [checked]=\"showFalseValues\" (change)=\"onShowFalseChange($event)\">\r\n            <span class=\"checkbox-ag-grid-label\">{{params.falseValueDisplayFormat}}</span>\r\n        </label>\r\n    </div>\r\n</div>\r\n\r\n", styles: ["@charset \"UTF-8\";.container{padding:.25rem}hr{margin:.25rem}.checkbox-ag-grid label{position:relative;display:flex}.checkbox-ag-grid label input{display:none}.checkbox-ag-grid label input:checked+.checkbox-ag-grid-label:after{content:\"\\2713\";display:inline-block;color:#0091ea;font-size:13px;position:absolute;left:2px;top:-2px}.checkbox-ag-grid label .checkbox-ag-grid-label{display:flex;align-items:center;font-size:12px}.checkbox-ag-grid label .checkbox-ag-grid-label:before{content:\"\";display:inline-block;color:#0091ea;height:15px;width:15px;border:solid 1px #0091ea;border-radius:3px;margin-right:.5rem}\n"] }]
        }], propDecorators: { checkboxContainer: [{
                type: ViewChild,
                args: ['container', { read: ViewContainerRef, static: true }]
            }], trueCheckbox: [{
                type: ViewChild,
                args: ['trueCheckbox', { read: ViewContainerRef, static: true }]
            }], falseCheckbox: [{
                type: ViewChild,
                args: ['falseCheckbox', { read: ViewContainerRef, static: true }]
            }] } });

class AgGridEnumSetFilterComponent {
    agInit(params) {
        //So far this is only an issue with server side queries, so default this to true
        if (params.isInServerSideFilterMode == null)
            params.isInServerSideFilterMode = true;
        this.params = params;
        this.values = params.values;
        this.valueGetter = params.valueGetter;
    }
    isFilterActive() {
        return !this.allValuesSelected;
    }
    doesFilterPass(params) {
        //We don't worry about passing when in server side mode, because all results will have
        //have been filtered down to what we need already. And this filter will ONLY be used in server side mode, because if not the standard set filter works
        return true;
    }
    getModel() {
        var builtFilter = null;
        let selectedValues = this.values.filter(x => x.selected == true);
        if (this.isFilterActive()) {
            builtFilter = {
                filterType: "enumSet",
                enumName: this.params.enumName,
                values: selectedValues.map(x => x.value)
            };
        }
        return builtFilter;
    }
    setModel(model) {
    }
    ngAfterViewInit(params) {
        window.setTimeout(() => {
            this.checkboxContainer.element.nativeElement.focus();
        });
    }
    get allValuesSelected() {
        return this.values.filter(a => a.selected).length == this.values.length;
    }
    onSelectAllChange(event) {
        for (let x = 0; x < this.values.length; x++) {
            this.values[x].selected = event.target.checked;
        }
        this.params.filterChangedCallback();
    }
    onSelectionChange(event) {
        this.values.filter(x => x.value == event.target.id)[0].selected = event.target.checked;
        this.params.values = this.values;
        this.params.filterChangedCallback();
    }
    tryGetValue(data, path) {
        let value = "";
        try {
            value = jp.value(data, path);
        }
        catch (error) {
            console.error(error);
        }
        return value;
    }
}
AgGridEnumSetFilterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AgGridEnumSetFilterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AgGridEnumSetFilterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: AgGridEnumSetFilterComponent, selector: "enum-set-filter", viewQueries: [{ propertyName: "checkboxContainer", first: true, predicate: ["container"], descendants: true, read: ViewContainerRef, static: true }, { propertyName: "selectAllCheckbox", first: true, predicate: ["selectAllCheckbox"], descendants: true, read: ViewContainerRef, static: true }], ngImport: i0, template: "<div #container class=\"container\">\r\n  Enum Set Filter:\r\n  <br>\r\n\r\n  <div class=\"checkbox-ag-grid\">\r\n    <label class=\"inline\">\r\n      <input #selectAllCheckbox type=\"checkbox\" [checked]=\"allValuesSelected\" (change)=\"onSelectAllChange($event)\">\r\n      <span class=\"checkbox-ag-grid-label\">Select All</span>\r\n    </label>\r\n  </div>\r\n  <hr />\r\n\r\n  <div *ngFor=\"let value of values\" class=\"checkbox-ag-grid\">\r\n    <label class=\"inline\">\r\n      <input type=\"checkbox\" [id]=\"value.value\" [checked]=\"value.selected\" (change)=\"onSelectionChange($event)\">\r\n      <span class=\"checkbox-ag-grid-label\">{{value.displayName}}</span>\r\n    </label>\r\n  </div>\r\n</div>\r\n", styles: ["@charset \"UTF-8\";.container{padding:.25rem}hr{margin:.25rem}.checkbox-ag-grid label{position:relative;display:flex}.checkbox-ag-grid label input{display:none}.checkbox-ag-grid label input:checked+.checkbox-ag-grid-label:after{content:\"\\2713\";display:inline-block;color:#0091ea;font-size:13px;position:absolute;left:2px;top:-2px}.checkbox-ag-grid label .checkbox-ag-grid-label{display:flex;align-items:center;font-size:12px}.checkbox-ag-grid label .checkbox-ag-grid-label:before{content:\"\";display:inline-block;color:#0091ea;height:15px;width:15px;border:solid 1px #0091ea;border-radius:3px;margin-right:.5rem}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AgGridEnumSetFilterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'enum-set-filter', template: "<div #container class=\"container\">\r\n  Enum Set Filter:\r\n  <br>\r\n\r\n  <div class=\"checkbox-ag-grid\">\r\n    <label class=\"inline\">\r\n      <input #selectAllCheckbox type=\"checkbox\" [checked]=\"allValuesSelected\" (change)=\"onSelectAllChange($event)\">\r\n      <span class=\"checkbox-ag-grid-label\">Select All</span>\r\n    </label>\r\n  </div>\r\n  <hr />\r\n\r\n  <div *ngFor=\"let value of values\" class=\"checkbox-ag-grid\">\r\n    <label class=\"inline\">\r\n      <input type=\"checkbox\" [id]=\"value.value\" [checked]=\"value.selected\" (change)=\"onSelectionChange($event)\">\r\n      <span class=\"checkbox-ag-grid-label\">{{value.displayName}}</span>\r\n    </label>\r\n  </div>\r\n</div>\r\n", styles: ["@charset \"UTF-8\";.container{padding:.25rem}hr{margin:.25rem}.checkbox-ag-grid label{position:relative;display:flex}.checkbox-ag-grid label input{display:none}.checkbox-ag-grid label input:checked+.checkbox-ag-grid-label:after{content:\"\\2713\";display:inline-block;color:#0091ea;font-size:13px;position:absolute;left:2px;top:-2px}.checkbox-ag-grid label .checkbox-ag-grid-label{display:flex;align-items:center;font-size:12px}.checkbox-ag-grid label .checkbox-ag-grid-label:before{content:\"\";display:inline-block;color:#0091ea;height:15px;width:15px;border:solid 1px #0091ea;border-radius:3px;margin-right:.5rem}\n"] }]
        }], propDecorators: { checkboxContainer: [{
                type: ViewChild,
                args: ['container', { read: ViewContainerRef, static: true }]
            }], selectAllCheckbox: [{
                type: ViewChild,
                args: ['selectAllCheckbox', { read: ViewContainerRef, static: true }]
            }] } });

class ActionCellRendererComponent {
    constructor() {
    }
    agInit(params) {
        this.params = params;
        if (params.formatter) {
            this.text = params.formatter({ data: params.data });
        }
        else if (params.text) {
            this.text = params.text;
        }
        else if (params.textField) {
            let fieldValue = params.data[params.textField];
            if (fieldValue != null && fieldValue != undefined) {
                this.text = fieldValue;
            }
        }
    }
    onClick() {
        this.params.action(this.params);
    }
}
ActionCellRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ActionCellRendererComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ActionCellRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: ActionCellRendererComponent, selector: "action-link-cell-renderer", ngImport: i0, template: `<div class='button-link' (click)='onClick()'>{{ text }}</div>`, isInline: true, styles: [".button-link{color:#8ab1d3;font-weight:700;cursor:pointer}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ActionCellRendererComponent, decorators: [{
            type: Component,
            args: [{ selector: "action-link-cell-renderer", template: `<div class='button-link' (click)='onClick()'>{{ text }}</div>`, styles: [".button-link{color:#8ab1d3;font-weight:700;cursor:pointer}\n"] }]
        }], ctorParameters: function () { return []; } });

class CheckboxRendererComponent {
    constructor() {
        this._isChecked = false;
        this._isVisible = true;
        this._isDisabled = false;
    }
    agInit(params) {
        this.params = params;
        //First set _isVisible based on isVisibleField property
        this._isVisible = params.data[params.isVisibleField] != null && params.data[params.isVisibleField] != undefined ? params.data[params.isVisibleField] : true;
        //now check if a method was provided, if so override _isVisible
        if (params.isVisible != null && params.isVisible != undefined)
            this._isVisible = this.params.isVisible(this.params);
        if (params.isDisabled != null && params.isDisabled != undefined)
            this._isDisabled = this.params.isDisabled(this.params);
        this._isChecked = params.data[params.field] != null && params.data[params.field] != undefined ? params.data[params.field] : false;
        if (params.valueGetter != null && params.valueGetter != undefined)
            this._isChecked = this.params.valueGetter(this.params);
    }
    refresh(params) {
        return false;
    }
    onClick() {
        this.params.action(this.params);
        this._isChecked = !this._isChecked;
    }
}
CheckboxRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CheckboxRendererComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
CheckboxRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: CheckboxRendererComponent, selector: "app-checkbox-renderer", ngImport: i0, template: "<ng-container *ngIf=\"_isVisible\">\r\n  <label [ngClass]=\"{'disabled': _isDisabled}\">\r\n    <input type=\"checkbox\" [disabled]=\"_isDisabled\" [checked]=\"_isChecked\" (click)=\"onClick()\" />\r\n    <button *ngIf=\"!_isChecked\">\r\n      <svg-icon-sprite [src]=\"'icon-checklist-unchecked'\" aria-hidden=\"true\" [classes]=\"'icon-checklist-unchecked--gray'\" [height]=\"'20'\" [width]=\"'20'\" [viewBox]=\"'0 0 20 20'\"></svg-icon-sprite>\r\n    </button>\r\n    <button *ngIf=\"_isChecked\">\r\n      <svg-icon-sprite [src]=\"'icon-checklist'\" aria-hidden=\"true\" [classes]=\"'icon-checklist--green'\" [height]=\"'20'\" [width]=\"'20'\" [viewBox]=\"'0 0 20 20'\"></svg-icon-sprite>\r\n    </button>\r\n  </label>\r\n</ng-container>\r\n", styles: ["label{display:grid;grid-template-columns:auto;grid-template-rows:auto;align-items:start;justify-content:center;width:18px;cursor:pointer}label input,label button{grid-column:1/2;grid-row:1/2;pointer-events:none}label input{display:none}label button{padding:0;margin:0;border:none;background-color:transparent}label.disabled{cursor:not-allowed!important}label.disabled button{opacity:.4}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$1.IconSpriteComponent, selector: "svg-icon-sprite", inputs: ["src", "classes", "width", "height", "viewBox", "preserveAspectRatio", "attribute", "title"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CheckboxRendererComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-checkbox-renderer', template: "<ng-container *ngIf=\"_isVisible\">\r\n  <label [ngClass]=\"{'disabled': _isDisabled}\">\r\n    <input type=\"checkbox\" [disabled]=\"_isDisabled\" [checked]=\"_isChecked\" (click)=\"onClick()\" />\r\n    <button *ngIf=\"!_isChecked\">\r\n      <svg-icon-sprite [src]=\"'icon-checklist-unchecked'\" aria-hidden=\"true\" [classes]=\"'icon-checklist-unchecked--gray'\" [height]=\"'20'\" [width]=\"'20'\" [viewBox]=\"'0 0 20 20'\"></svg-icon-sprite>\r\n    </button>\r\n    <button *ngIf=\"_isChecked\">\r\n      <svg-icon-sprite [src]=\"'icon-checklist'\" aria-hidden=\"true\" [classes]=\"'icon-checklist--green'\" [height]=\"'20'\" [width]=\"'20'\" [viewBox]=\"'0 0 20 20'\"></svg-icon-sprite>\r\n    </button>\r\n  </label>\r\n</ng-container>\r\n", styles: ["label{display:grid;grid-template-columns:auto;grid-template-rows:auto;align-items:start;justify-content:center;width:18px;cursor:pointer}label input,label button{grid-column:1/2;grid-row:1/2;pointer-events:none}label input{display:none}label button{padding:0;margin:0;border:none;background-color:transparent}label.disabled{cursor:not-allowed!important}label.disabled button{opacity:.4}\n"] }]
        }], ctorParameters: function () { return []; } });

class SVGIcon {
    constructor() {
        //Can either be the string, or a function that when given params returns the string
        this.hoverText = "";
        this.isVisible = true;
        this.viewBox = '0 0 20 20';
        this.methodParams = null;
    }
}

class SVGIconButton extends SVGIcon {
}

class SVGIconComponent {
    constructor() {
        /**
         * @remarks
         * This component will display a svg icon
         * @param methodParams - The object to be passed into any of the inputs that can be functions
         * @param iconType - What icon to display
         * @param color - What color of icon to display
         * @param hoverText - What text to display while cursor is over icon, can be a string or function that can return a string
         * @param height - Height of icon to display
         * @param width - Width of icon to display
         * @param isVisible - Whether the icon is visible, can be boolean or function that returns boolean
         * @param viewBox - Viewbox of the svg icon
         * @param svgIcon - Alternatively, pass an instance of the SVGIcon from which the other properties will be pulled
         */
        this.defaultIconSize = "22";
        this.iconClass = "";
        this.finalHeight = "22";
        this.finalWidth = "22";
        this.finalHoverText = "";
        this.finalIsVisible = true;
        this.methodParams = null;
        this.iconType = "";
        this.hoverText = "";
        this.height = 18;
        this.width = 18;
        this.isVisible = true;
        this.viewBox = "0 0 20 20";
        this.svgIcon = null;
    }
    ngOnInit() {
        if (this.svgIcon != null) {
            this.class = this.svgIcon.class;
            this.height = this.svgIcon.height;
            this.hoverText = this.svgIcon.hoverText;
            this.iconType = this.svgIcon.iconType;
            this.isVisible = this.svgIcon.isVisible;
            this.viewBox = this.svgIcon.viewBox;
            this.width = this.svgIcon.width;
            this.methodParams = this.svgIcon.methodParams;
        }
        //now run through and determine final values for the relevant fields
        this.iconClass = this.determineIconClass();
        this.finalHeight = this.calculateHeight();
        this.finalWidth = this.calculateWidth();
        this.finalHoverText = this.defineHoverText();
        this.finalIsVisible = this.determineIsVisible();
    }
    determineIconClass() {
        let iconClass = "";
        if (this.class instanceof Function)
            iconClass = this.class(this.methodParams);
        else if (isNotNullOrEmpty(this.class))
            iconClass = this.class;
        return iconClass;
    }
    calculateWidth() {
        let width = this.width !== null && this.width !== undefined ? this.width.toString() : this.defaultIconSize;
        return width;
    }
    calculateHeight() {
        let height = this.height != null && this.height != undefined ? this.height.toString() : this.defaultIconSize;
        return height;
    }
    defineHoverText() {
        let title = "";
        if (this.hoverText instanceof Function)
            title = this.hoverText(this.methodParams);
        else if (isNotNullOrEmpty(this.hoverText))
            title = this.hoverText;
        return title;
    }
    determineIsVisible() {
        let isVisible = true;
        if (this.isVisible instanceof Function)
            isVisible = this.isVisible(this.methodParams);
        else if (this.isVisible != undefined && this.isVisible != null)
            isVisible = this.isVisible;
        return isVisible;
    }
}
SVGIconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SVGIconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SVGIconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: SVGIconComponent, selector: "svg-icon", inputs: { methodParams: "methodParams", iconType: "iconType", class: "class", hoverText: "hoverText", height: "height", width: "width", isVisible: "isVisible", viewBox: "viewBox", svgIcon: "svgIcon" }, ngImport: i0, template: "<svg-icon-sprite *ngIf=\"finalIsVisible\" [title]=\"finalHoverText\" [attr.aria-label]=\"finalHoverText\" [src]=\"iconType\" [classes]=\"iconClass\" [height]=\"finalHeight\" [width]=\"finalWidth\" [viewBox]=\"viewBox\"></svg-icon-sprite>\r\n", styles: [":host{display:flex;align-items:center;gap:.25rem}.hide{display:none}svg-icon-sprite{display:flex}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$1.IconSpriteComponent, selector: "svg-icon-sprite", inputs: ["src", "classes", "width", "height", "viewBox", "preserveAspectRatio", "attribute", "title"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SVGIconComponent, decorators: [{
            type: Component,
            args: [{ selector: "svg-icon", template: "<svg-icon-sprite *ngIf=\"finalIsVisible\" [title]=\"finalHoverText\" [attr.aria-label]=\"finalHoverText\" [src]=\"iconType\" [classes]=\"iconClass\" [height]=\"finalHeight\" [width]=\"finalWidth\" [viewBox]=\"viewBox\"></svg-icon-sprite>\r\n", styles: [":host{display:flex;align-items:center;gap:.25rem}.hide{display:none}svg-icon-sprite{display:flex}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { methodParams: [{
                type: Input
            }], iconType: [{
                type: Input
            }], class: [{
                type: Input
            }], hoverText: [{
                type: Input
            }], height: [{
                type: Input
            }], width: [{
                type: Input
            }], isVisible: [{
                type: Input
            }], viewBox: [{
                type: Input
            }], svgIcon: [{
                type: Input
            }] } });

class SVGIconButtonComponent {
    constructor() {
        /**
         * @remarks
         * This component will display an clickable svg icon button
         * @param svgIconButton - An instance of the SVGIconButton class
         */
        this.svgIconButton = new SVGIconButton();
        this.methodParams = null;
        this.subscription = new Subscription();
        this.isDisabled = false;
        this.finalIsVisible = true;
        this.finalHoverText = "";
        this.onClickHandler = () => { };
        this.childSvgIconComponent = new SVGIconComponent();
    }
    ngOnInit() {
    }
    ngOnDestroy() {
        if (this.subscription)
            this.subscription.unsubscribe();
    }
    ngAfterViewInit() {
        if (this.childSvgIconComponent) {
            if (this.childSvgIconComponent.methodParams)
                this.methodParams = this.childSvgIconComponent.methodParams;
        }
        if (this.svgIconButton) {
            this.onClickHandler = this.svgIconButton.onClickHandler;
            this.isDisabledEmitter = this.svgIconButton.isDisabledEmitter;
            if (this.isDisabledEmitter) {
                var disabledListener$ = this.isDisabledEmitter.pipe(finalize(() => {
                    this.subscription.add(disabledListener$);
                })).subscribe(isDisabled => {
                    this.isDisabled = isDisabled;
                });
            }
        }
    }
    onClick() {
        this.onClickHandler(this.methodParams);
        console.log("clicked");
    }
}
SVGIconButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SVGIconButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SVGIconButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: SVGIconButtonComponent, selector: "svg-icon-button", inputs: { svgIconButton: "svgIconButton", methodParams: "methodParams" }, viewQueries: [{ propertyName: "childSvgIconComponent", first: true, predicate: ["svgIconComponent"], descendants: true }], ngImport: i0, template: "<button *ngIf=\"finalIsVisible\" [disabled]=\"isDisabled\" class=\"button-no-border\" [title]=\"finalHoverText\" [attr.aria-label]=\"finalHoverText\" (click)=\"onClick()\">\r\n  <svg-icon #svgIconComponent [svgIcon]=\"svgIconButton\"></svg-icon>\r\n</button>\r\n", styles: [":host{display:inline-flex;align-items:center}.button-no-border{outline:none;border:none;background:transparent;cursor:pointer;padding:0}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: SVGIconComponent, selector: "svg-icon", inputs: ["methodParams", "iconType", "class", "hoverText", "height", "width", "isVisible", "viewBox", "svgIcon"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SVGIconButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: "svg-icon-button", template: "<button *ngIf=\"finalIsVisible\" [disabled]=\"isDisabled\" class=\"button-no-border\" [title]=\"finalHoverText\" [attr.aria-label]=\"finalHoverText\" (click)=\"onClick()\">\r\n  <svg-icon #svgIconComponent [svgIcon]=\"svgIconButton\"></svg-icon>\r\n</button>\r\n", styles: [":host{display:inline-flex;align-items:center}.button-no-border{outline:none;border:none;background:transparent;cursor:pointer;padding:0}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { svgIconButton: [{
                type: Input
            }], methodParams: [{
                type: Input
            }], childSvgIconComponent: [{
                type: ViewChild,
                args: ['svgIconComponent', { static: false }]
            }] } });

class IconButtonsRendererComponent {
    constructor() {
        this.buttonsToShow = [];
    }
    agInit(params) {
        this.params = params;
        this.buttonsToShow = params.buttons;
        for (let x = 0; x < this.buttonsToShow.length; x++) {
            this.buttonsToShow[x].methodParams = this.params;
        }
    }
    refresh(params) { return false; }
}
IconButtonsRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: IconButtonsRendererComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IconButtonsRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: IconButtonsRendererComponent, selector: "icon-button-cell-renderer", ngImport: i0, template: "<ng-container *ngFor=\"let button of buttonsToShow\">\r\n  <svg-icon-button [svgIconButton]=\"button\"></svg-icon-button>\r\n</ng-container>\r\n\r\n\r\n", styles: [":host{display:flex;align-items:center}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: SVGIconButtonComponent, selector: "svg-icon-button", inputs: ["svgIconButton", "methodParams"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: IconButtonsRendererComponent, decorators: [{
            type: Component,
            args: [{ selector: "icon-button-cell-renderer", template: "<ng-container *ngFor=\"let button of buttonsToShow\">\r\n  <svg-icon-button [svgIconButton]=\"button\"></svg-icon-button>\r\n</ng-container>\r\n\r\n\r\n", styles: [":host{display:flex;align-items:center}\n"] }]
        }], ctorParameters: function () { return []; } });

var InlineEditDeleteButtonType;
(function (InlineEditDeleteButtonType) {
    InlineEditDeleteButtonType[InlineEditDeleteButtonType["Edit"] = 0] = "Edit";
    InlineEditDeleteButtonType[InlineEditDeleteButtonType["Delete"] = 1] = "Delete";
    InlineEditDeleteButtonType[InlineEditDeleteButtonType["Update"] = 2] = "Update";
    InlineEditDeleteButtonType[InlineEditDeleteButtonType["Cancel"] = 3] = "Cancel";
})(InlineEditDeleteButtonType || (InlineEditDeleteButtonType = {}));

class InlineEditDeleteRendererComponent {
    constructor() {
        this.noDisabledEmitterProvidedWithParams = false;
        this.canDelete = true;
        this.promptToConfirmSave = true;
        this.promptToConfirmDeletion = true;
        this.editButton = { isVisible: false };
        this.deleteButton = { isVisible: false };
        this.updateButton = { isVisible: false };
        this.cancelButton = { isVisible: false };
        this.isNew = true;
    }
    agInit(params) {
        if (params.isDisabledEmitter == null || params.isDisabledEmitter == undefined) {
            params.isDisabledEmitter = new EventEmitter(true);
            this.noDisabledEmitterProvidedWithParams = true;
        }
        this.params = params;
        if (this.params.canDelete !== null && this.params.canDelete !== undefined)
            this.canDelete = this.params.canDelete instanceof Function ? this.params.canDelete(params) : this.params.canDelete;
        if (this.params.promptToConfirmSave !== null && this.params.promptToConfirmSave !== undefined)
            this.canDelete = this.params.promptToConfirmSave;
        if (this.params.promptToConfirmDeletion !== null && this.params.promptToConfirmDeletion !== undefined)
            this.promptToConfirmDeletion = this.params.promptToConfirmDeletion;
        let editButtonSvgInfo = this.params.buttonIcons.filter(x => x.buttonType == InlineEditDeleteButtonType.Edit);
        let deleteButtonSvgInfo = this.params.buttonIcons.filter(x => x.buttonType == InlineEditDeleteButtonType.Delete);
        let updateButtonSvgInfo = this.params.buttonIcons.filter(x => x.buttonType == InlineEditDeleteButtonType.Update);
        let cancelButtonSvgInfo = this.params.buttonIcons.filter(x => x.buttonType == InlineEditDeleteButtonType.Cancel);
        if (editButtonSvgInfo.length > 0) {
            this.editButton = { methodParams: this, isDisabledEmitter: params.isDisabledEmitter, onClickHandler: this.enableEditMode, iconType: editButtonSvgInfo[0].iconType, class: editButtonSvgInfo[0].class, hoverText: "Edit", height: 24, width: 24 };
        }
        if (deleteButtonSvgInfo.length > 0) {
            this.deleteButton = { methodParams: this, isDisabledEmitter: params.isDisabledEmitter, onClickHandler: this.onDeleteClick, iconType: deleteButtonSvgInfo[0].iconType, class: deleteButtonSvgInfo[0].class, hoverText: "Delete", height: 24, width: 24 };
        }
        if (updateButtonSvgInfo.length > 0) {
            this.updateButton = { methodParams: this, isDisabledEmitter: params.isDisabledEmitter, onClickHandler: this.onUpdateClick, iconType: updateButtonSvgInfo[0].iconType, class: updateButtonSvgInfo[0].class, hoverText: "Save", height: 24, width: 24 };
        }
        if (cancelButtonSvgInfo.length > 0) {
            this.cancelButton = { methodParams: this, isDisabledEmitter: params.isDisabledEmitter, onClickHandler: this.onCancelClick, iconType: cancelButtonSvgInfo[0].iconType, class: cancelButtonSvgInfo[0].class, hoverText: "Cancel", height: 24, width: 24 };
        }
        if (this.params.node.data.id == '' || this.params.node.data.id == 0) {
            this.enableEditMode();
        }
        this.params.api.addEventListener(Events.EVENT_ROW_EDITING_STOPPED, this.onRowEditingStoppedEvent);
    }
    refresh() {
        return true;
    }
    enableEditMode(parentComponent = this) {
        parentComponent.params.isDisabledEmitter.emit(true);
        parentComponent.isNew = false;
        parentComponent.previousData = JSON.parse(JSON.stringify(parentComponent.params.node.data));
        let cols = parentComponent.params.columnApi.getAllGridColumns();
        let editableCells = [];
        if (cols) {
            editableCells = cols.filter(c => c.isCellEditable(parentComponent.params.node));
        }
        parentComponent.params.api.startEditingCell({
            rowIndex: parentComponent.params.node.rowIndex,
            // gets the first columnKey
            colKey: editableCells.length > 0 ? editableCells[0].getId() : "0",
        });
        parentComponent.params.isDisabledEmitter.emit(false);
    }
    onUpdateClick(parentComponent = this) {
        parentComponent.params.isDisabledEmitter.emit(true);
        parentComponent.isNew = true;
        parentComponent.params.api.stopEditing();
        parentComponent.params.onSaveHandler(parentComponent.params);
        parentComponent.previousData = null;
        //Assumption that if no emitter was originally provided in params, the passed in savehandler won't handle emitting enabled
        if (!parentComponent.noDisabledEmitterProvidedWithParams)
            parentComponent.params.isDisabledEmitter.emit(false);
    }
    onCancelClick(parentComponent = this, triggeredFromRowEditingStoppedEvent = false) {
        parentComponent.params.isDisabledEmitter.emit(true);
        parentComponent.isNew = true;
        if (parentComponent.previousData !== null && parentComponent.previousData !== undefined && parentComponent.previousData.id !== ''
            && parentComponent.previousData.id !== 0) {
            parentComponent.params.node.setData(parentComponent.previousData);
            parentComponent.previousData = null;
        }
        if (!triggeredFromRowEditingStoppedEvent)
            parentComponent.params.api.stopEditing(true);
        parentComponent.params.isDisabledEmitter.emit(false);
    }
    onDeleteClick(parentComponent = this) {
        parentComponent.params.isDisabledEmitter.emit(true);
        parentComponent.params.api.stopEditing();
        parentComponent.params.onDeleteHandler(parentComponent.params);
        //Assumption that if no emitter was originally provided in params, the passed in savehandler won't handle emitting enabled
        if (!parentComponent.noDisabledEmitterProvidedWithParams)
            parentComponent.params.isDisabledEmitter.emit(false);
    }
    onRowEditingStoppedEvent(event) {
        let getCellRendererParams = { rowNodes: [event.node] };
        let renderers = event.api.getCellRendererInstances(getCellRendererParams);
        let inlineEditDeleteRenderer = renderers.filter(a => a instanceof InlineEditDeleteRendererComponent)[0];
        inlineEditDeleteRenderer.onCancelClick(inlineEditDeleteRenderer, true);
    }
}
InlineEditDeleteRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: InlineEditDeleteRendererComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
InlineEditDeleteRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: InlineEditDeleteRendererComponent, selector: "inline-edit-delete-column-renderer.component", ngImport: i0, template: "<svg-icon-button *ngIf=\"isNew\" [svgIconButton]=\"editButton\"></svg-icon-button>\r\n<svg-icon-button *ngIf=\"isNew && canDelete\" [svgIconButton]=\"deleteButton\"></svg-icon-button>\r\n<svg-icon-button *ngIf=\"!isNew\" [svgIconButton]=\"updateButton\"></svg-icon-button>\r\n<svg-icon-button *ngIf=\"!isNew\" [svgIconButton]=\"cancelButton\"></svg-icon-button>\r\n", styles: [":host{display:flex;justify-content:center}button{border:none!important;background-color:transparent;cursor:pointer;padding:0;margin-right:.25rem}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: SVGIconButtonComponent, selector: "svg-icon-button", inputs: ["svgIconButton", "methodParams"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: InlineEditDeleteRendererComponent, decorators: [{
            type: Component,
            args: [{ selector: 'inline-edit-delete-column-renderer.component', template: "<svg-icon-button *ngIf=\"isNew\" [svgIconButton]=\"editButton\"></svg-icon-button>\r\n<svg-icon-button *ngIf=\"isNew && canDelete\" [svgIconButton]=\"deleteButton\"></svg-icon-button>\r\n<svg-icon-button *ngIf=\"!isNew\" [svgIconButton]=\"updateButton\"></svg-icon-button>\r\n<svg-icon-button *ngIf=\"!isNew\" [svgIconButton]=\"cancelButton\"></svg-icon-button>\r\n", styles: [":host{display:flex;justify-content:center}button{border:none!important;background-color:transparent;cursor:pointer;padding:0;margin-right:.25rem}\n"] }]
        }], ctorParameters: function () { return []; } });

class RouterLinkRendererComponent {
    constructor(ngZone, router) {
        this.ngZone = ngZone;
        this.router = router;
        this.openInNewWindow = false;
    }
    agInit(params) {
        this.params = params;
        if (params.data) {
            this.id = params.data[params.idField];
            if (params.text) {
                this.linkText = params.text;
            }
            else if (params.textField) {
                this.linkText = (params.data[params.textField]) ? params.data[params.textField] : "Unknown";
            }
            else if (params.enumValueField && params.enum) {
                this.linkText = params.enum.find(x => x.id === params.data[params.enumValueField]).description;
            }
            if (params.url && typeof (params.url) == 'function') {
                params.url = params.url(params.data);
            }
            if (!params.url && params.data.targetUrl) {
                params.url = params.data.targetUrl;
            }
            if (params.openInNewWindow !== undefined && params.openInNewWindow !== null) {
                this.openInNewWindow = params.openInNewWindow;
            }
            if (params.function)
                params.url = params.function(params.data);
            this.url = params.url;
        }
    }
    onNavigationConfirm() {
        this.doNavigation();
    }
    onNavigationCancel() {
    }
    doNavigation() {
        if (!this.params.preventNavigation) {
            if (this.id) {
                this.ngZone.run(() => { this.router.navigate([this.url, this.id]); });
            }
            else {
                this.ngZone.run(() => { this.router.navigate([this.url]); });
            }
        }
    }
    refresh(params) {
        return false;
    }
    navigate(link) {
        this.doNavigation();
    }
}
RouterLinkRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: RouterLinkRendererComponent, deps: [{ token: i0.NgZone }, { token: i1$1.Router }], target: i0.ɵɵFactoryTarget.Component });
RouterLinkRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: RouterLinkRendererComponent, selector: "app-router-link-renderer", ngImport: i0, template: "<ng-container *ngIf=\"openInNewWindow; else nav\">\r\n    <a [href]=\"url\" target=\"_blank\">\r\n        {{ linkText }}\r\n    </a>\r\n</ng-container>\r\n<ng-template #nav>\r\n    <a (click)=\"navigate(url)\">\r\n        {{ linkText }}\r\n    </a>\r\n</ng-template>\r\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: RouterLinkRendererComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-router-link-renderer', template: "<ng-container *ngIf=\"openInNewWindow; else nav\">\r\n    <a [href]=\"url\" target=\"_blank\">\r\n        {{ linkText }}\r\n    </a>\r\n</ng-container>\r\n<ng-template #nav>\r\n    <a (click)=\"navigate(url)\">\r\n        {{ linkText }}\r\n    </a>\r\n</ng-template>\r\n" }]
        }], ctorParameters: function () { return [{ type: i0.NgZone }, { type: i1$1.Router }]; } });

class SwitchRendererComponent {
    constructor() {
        this._isChecked = false;
        this._isVisible = true;
    }
    agInit(params) {
        this.params = params;
        //First set _isVisible based on isVisibleField property
        this._isVisible = params.data[params.isVisibleField] != null && params.data[params.isVisibleField] != undefined ? params.data[params.isVisibleField] : true;
        //now check if a method was provided, if so override _isVisible
        if (params.isVisible != null && params.isVisible != undefined)
            this._isVisible = this.params.isVisible(this.params);
        this._isChecked = params.data[params.field] != null && params.data[params.field] != undefined ? params.data[params.field] : false;
    }
    refresh(params) {
        return false;
    }
    onClick() {
        this.params.action(this.params.data);
        this._isChecked = !this._isChecked;
    }
}
SwitchRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SwitchRendererComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SwitchRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: SwitchRendererComponent, selector: "app-switch-renderer", ngImport: i0, template: "<ng-container *ngIf=\"_isVisible\">\r\n    <div>\r\n        <input (click)=\"onClick()\" name=\"switch\" type=\"checkbox\" [checked]=\"_isChecked\">\r\n    </div>\r\n</ng-container>", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SwitchRendererComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-switch-renderer', template: "<ng-container *ngIf=\"_isVisible\">\r\n    <div>\r\n        <input (click)=\"onClick()\" name=\"switch\" type=\"checkbox\" [checked]=\"_isChecked\">\r\n    </div>\r\n</ng-container>" }]
        }], ctorParameters: function () { return []; } });

function dateComparator(date1, date2) {
    var date1Number = parseDate(date1);
    var date2Number = parseDate(date2);
    let returnValue = dateComparison(date2Number, date1Number);
    return returnValue;
}
function dateFilterComparator(filterLocalDateAtMidnight, cellValue) {
    var dateAsString = cellValue;
    if (dateAsString == null)
        return 0;
    let cellDate = parseDate(dateAsString);
    let returnValue = dateComparison(filterLocalDateAtMidnight, cellDate);
    return returnValue;
}
function dateComparison(date1, date2) {
    let returnValue = 0;
    if (!(date1 === null && date2 === null)) {
        if (date2 < date1) {
            returnValue = -1;
        }
        else if (date2 > date1) {
            returnValue = 1;
        }
    }
    return returnValue;
}
function parseDate(dateAsString) {
    if (dateAsString === undefined || dateAsString === null) {
        return null;
    }
    var date = new Date(dateAsString);
    if (isNaN(date.getTime()))
        date = null;
    return date;
}

class GridFormatterService {
    constructor(datePipe, currencyPipe) {
        this.datePipe = datePipe;
        this.currencyPipe = currencyPipe;
        this.dateFormat = 'MM/dd/yyyy';
        this.defaultTextFilterParams = { debounceMs: 500, resetButton: true };
        this.defaultNumberFilterParams = { debounceMs: 500, resetButton: true };
        this.defaultDateFilterParams = { comparator: dateFilterComparator, resetButton: true, browserDatePicker: true };
        this.defaultSetFilterParams = { suppressMiniFilter: true };
        this.defaultBooleanFilterParams = { falseValueDisplayFormat: 'No', trueValueDisplayFormat: 'Yes', isInServerSideFilterMode: true, };
        this.defaultColDef = { filter: true, resizable: true, sortable: true, filterParams: this.defaultSetFilterParams };
        this.defaultGridOptions = {
            defaultColDef: this.defaultColDef,
            enableBrowserTooltips: true,
            pagination: true,
            paginationAutoPageSize: true,
            suppressHorizontalScroll: false,
        };
        this.defaultGridOptionsServerSide = {
            cacheOverflowSize: 2,
            cacheBlockSize: 100,
            maxConcurrentDatasourceRequests: 1,
            maxBlocksInCache: 10,
            paginationPageSize: 100,
            rowBuffer: 0,
            rowSelection: "multiple",
            rowModelType: "serverSide",
            suppressHorizontalScroll: false,
            defaultColDef: this.defaultColDef,
            enableBrowserTooltips: true,
            pagination: true,
            serverSideStoreType: "partial"
        };
        this.excelStyles = [
            {
                id: 'booleanType',
                dataType: 'boolean',
            },
            {
                id: 'stringType',
                dataType: 'string',
            },
            {
                id: 'dateType',
                dataType: 'dateTime',
            },
        ];
    }
    BuildDefaultGridOptionsWithColumns(columns, isServerSide = false, canFilter = true, canSort = true, autoSizeColumns = false, suppressMenuHide = true) {
        let gridOptions = isServerSide ? JSON.parse(JSON.stringify(this.defaultGridOptionsServerSide)) : JSON.parse(JSON.stringify(this.defaultGridOptions));
        gridOptions.defaultColDef.filter = canFilter;
        gridOptions.defaultColDef.sortable = canSort;
        gridOptions.columnDefs = columns;
        gridOptions.editType = 'fullRow';
        gridOptions.suppressMenuHide = suppressMenuHide;
        gridOptions.suppressRowHoverHighlight = true;
        gridOptions.suppressCopyRowsToClipboard = true;
        if (autoSizeColumns) {
            gridOptions.onGridReady = () => {
                gridOptions.api.sizeColumnsToFit();
                gridOptions.columnApi.autoSizeAllColumns();
            };
        }
        else {
            gridOptions.onGridReady = () => {
                gridOptions.api.sizeColumnsToFit();
            };
        }
        return gridOptions;
    }
    formatDate(field, format = this.dateFormat, defaultText = "N/A", displayNothingIfParentObjectIsNull = false) {
        return (obj) => {
            if (!displayNothingIfParentObjectIsNull || (displayNothingIfParentObjectIsNull && obj.data != null)) {
                let fieldValue = this.tryGetValue(obj.data, field);
                if (!this.isNullUndefinedOrEmpty(fieldValue) && fieldValue !== "{}")
                    return this.datePipe.transform(fieldValue, format);
                else
                    return defaultText;
            }
            else {
                return "";
            }
        };
    }
    formatNumberPrecision(field, precision, defaultText = "") {
        return (obj) => {
            let fieldValue = this.tryGetValue(obj.data, field);
            if (!this.isNullUndefinedOrEmpty(fieldValue))
                return Number(fieldValue).toFixed(precision);
            else
                return defaultText;
        };
    }
    formatBooleanToYesNo(field) {
        return (obj) => {
            if (obj.data) {
                let fieldValue = this.tryGetValue(obj.data, field);
                if (fieldValue != undefined && fieldValue != null)
                    return fieldValue ? 'Yes' : 'No';
                else
                    return this.getUndefinedFieldValue();
            }
            else
                return this.getUndefinedFieldValue();
        };
    }
    gridReadySizeToFit(params) {
        let gridResizeTimeout;
        window.addEventListener('resize', () => {
            //throttle
            clearTimeout(gridResizeTimeout);
            gridResizeTimeout = setTimeout(() => {
                params.api.sizeColumnsToFit();
            }, 100);
        });
        params.api.sizeColumnsToFit();
    }
    arraySelectorFormatter(field, options, index = null, defaultValue = "N/A") {
        return (obj) => {
            if (!options)
                return "";
            if (obj.data) {
                let fieldValue = this.tryGetValue(obj.data, field);
                if (fieldValue != undefined && fieldValue != null) {
                    if (index == null) {
                        return options(fieldValue);
                    }
                    return options(fieldValue[index]);
                }
                else
                    return defaultValue;
            }
            else
                return defaultValue;
        };
    }
    exportDataToExcel(fileName, sheetName, api, selectedOnly = false) {
        const params = {
            skipHeader: false,
            allColumns: true,
            fileName: fileName,
            sheetName: sheetName,
            onlySelected: selectedOnly,
            onlySelectedAllPages: selectedOnly,
            processCellCallback: (params) => this.processCallback(params)
        };
        api.exportDataAsExcel(params);
    }
    flagEnumFormatter(field, enumObject, selectedFlagEnumValue, formatAsBool = false) {
        return (obj) => {
            var yesNoResult = "No";
            if (enumObject && obj.data && selectedFlagEnumValue != null && selectedFlagEnumValue != undefined) {
                let fieldValue = this.tryGetValue(obj.data, field);
                if (fieldValue != undefined && fieldValue != null) {
                    if (!formatAsBool)
                        yesNoResult = (fieldValue & enumObject[selectedFlagEnumValue]) > 0 ? "Yes" : "No";
                    else
                        yesNoResult = (fieldValue & enumObject[selectedFlagEnumValue]) > 0;
                }
            }
            return yesNoResult;
        };
    }
    formatPotentiallyBlankField(field, valueWhenBlank) {
        return (obj) => { return (obj.data && obj.data[field] && obj.data[field].length > 0) ? obj.data[field] : valueWhenBlank; };
    }
    formatCurrency(field, displayNothingIfParentObjectIsNull = false, currency = 'USD', display = 'symbol', digits = '1.2-2') {
        return (obj) => {
            if (!displayNothingIfParentObjectIsNull || (displayNothingIfParentObjectIsNull && obj.data != null)) {
                if (obj.data && obj.data[field] && obj.data[field] !== "{}") {
                    return this.currencyPipe.transform(obj.data[field], currency, display, digits);
                }
                return this.currencyPipe.transform(0, currency, display, digits);
            }
            else {
                return "";
            }
        };
    }
    tryGetValue(data, path) {
        let value = "";
        try {
            if (data != null) {
                //Prefix dollar sign operator if doesn't exist
                if (!path.startsWith("$."))
                    path = "$." + path;
                value = jp.value(data, path);
            }
        }
        catch (error) {
            console.error(`Error in path: ${path}`);
            console.error(error);
        }
        return value;
    }
    isNullUndefinedOrEmpty(data) {
        return data === null || data === undefined || data === "";
    }
    processCallback(params) {
        const colDef = params.column.getColDef();
        let returnValue = params.value;
        colDef.valueFormatter = colDef.valueFormatter;
        if (colDef.valueFormatter) {
            const valueFormatterParams = {
                ...params,
                data: params.node.data,
                node: params.node,
                colDef: params.column.getColDef()
            };
            returnValue = colDef.valueFormatter(valueFormatterParams);
        }
        return returnValue;
    }
    formatBooleanTooltip(field) {
        return (obj) => {
            if (obj.data) {
                const fieldValue = this.tryGetValue(obj.data, field);
                if (fieldValue !== undefined && fieldValue !== null)
                    if (fieldValue)
                        return "Switch to 'No'";
                    else
                        return "Switch to 'Yes'";
                else
                    return this.getUndefinedFieldValue();
            }
            else
                return this.getUndefinedFieldValue();
        };
    }
    getUndefinedFieldValue() {
        return "N/A";
    }
    resizeGridColumns(gridApi, delayInMilliseconds = 750) {
        if (gridApi) {
            //gives time for CSS to execute
            const timer = setTimeout(() => {
                //@ts-ignore
                gridApi.sizeColumnsToFit();
            }, delayInMilliseconds);
        }
    }
    /// @description: 
    /**
    * Formats a grid's column value that is a percentage to 2 decimal places.
    * @param params - ValueFormatterParams
    * @example
    * Here's an example with negative numbers:
    * ```
    * colDefs.push({
        field: "testNumberField",
        filter: "agNumberColumnFilter",
        filterParams: defaultNumberFilterParams,
        valueFormatter: this.percentageValueFormatter
      } as ColDef);
    * ```
    */
    percentageValueFormatter(params) {
        let formattedPercentageValue = 0;
        if (params.value != null && params.value != undefined && params.value != 0) {
            if (typeof (params.value) === 'string') {
                params.value = Number(params.value);
            }
            formattedPercentageValue = params.value.toFixed(2);
        }
        return `${formattedPercentageValue}%`;
    }
}
GridFormatterService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: GridFormatterService, deps: [{ token: i1.DatePipe }, { token: i1.CurrencyPipe }], target: i0.ɵɵFactoryTarget.Injectable });
GridFormatterService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: GridFormatterService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: GridFormatterService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.DatePipe }, { type: i1.CurrencyPipe }]; } });

class SVGIconModule {
}
SVGIconModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SVGIconModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SVGIconModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: SVGIconModule, declarations: [SVGIconComponent,
        SVGIconButtonComponent], imports: [CommonModule, i2$1.IconSpriteModule], exports: [SVGIconComponent,
        SVGIconButtonComponent] });
SVGIconModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SVGIconModule, imports: [CommonModule,
        IconSpriteModule.forRoot({ path: './ag-grid-extensions/content/sprite.svg' })] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SVGIconModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        SVGIconComponent,
                        SVGIconButtonComponent
                    ],
                    imports: [
                        CommonModule,
                        IconSpriteModule.forRoot({ path: './ag-grid-extensions/content/sprite.svg' })
                    ],
                    exports: [
                        SVGIconComponent,
                        SVGIconButtonComponent
                    ],
                    providers: []
                }]
        }] });

class AgGridLibraryModule {
}
AgGridLibraryModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AgGridLibraryModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AgGridLibraryModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: AgGridLibraryModule, declarations: [AgGridBooleanFilterComponent,
        AgGridEnumSetFilterComponent,
        ActionCellRendererComponent,
        RouterLinkRendererComponent,
        SwitchRendererComponent,
        CheckboxRendererComponent,
        IconButtonsRendererComponent,
        InlineEditDeleteRendererComponent,
        NumericEditorComponent,
        BooleanEditorComponent,
        DatePickerEditorComponent,
        NgSelectEditorComponent], imports: [CommonModule,
        FormsModule,
        AngularMyDatePickerModule,
        NgSelectModule,
        AgGridModule,
        SVGIconModule, i2$1.IconSpriteModule], exports: [AgGridBooleanFilterComponent,
        AgGridEnumSetFilterComponent,
        ActionCellRendererComponent,
        RouterLinkRendererComponent,
        SwitchRendererComponent,
        CheckboxRendererComponent,
        AgGridModule,
        IconButtonsRendererComponent,
        InlineEditDeleteRendererComponent,
        NumericEditorComponent,
        BooleanEditorComponent,
        DatePickerEditorComponent,
        NgSelectEditorComponent] });
AgGridLibraryModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AgGridLibraryModule, providers: [
        GridFormatterService,
        DatePickerHelperService,
        DatePipe,
        CurrencyPipe
    ], imports: [CommonModule,
        FormsModule,
        AngularMyDatePickerModule,
        NgSelectModule,
        AgGridModule,
        SVGIconModule,
        IconSpriteModule.forRoot({ path: './ag-grid-extensions/content/sprite.svg' }), AgGridModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AgGridLibraryModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        AgGridBooleanFilterComponent,
                        AgGridEnumSetFilterComponent,
                        ActionCellRendererComponent,
                        RouterLinkRendererComponent,
                        SwitchRendererComponent,
                        CheckboxRendererComponent,
                        IconButtonsRendererComponent,
                        InlineEditDeleteRendererComponent,
                        NumericEditorComponent,
                        BooleanEditorComponent,
                        DatePickerEditorComponent,
                        NgSelectEditorComponent
                    ],
                    imports: [
                        CommonModule,
                        FormsModule,
                        AngularMyDatePickerModule,
                        NgSelectModule,
                        AgGridModule,
                        SVGIconModule,
                        IconSpriteModule.forRoot({ path: './ag-grid-extensions/content/sprite.svg' })
                    ],
                    exports: [
                        AgGridBooleanFilterComponent,
                        AgGridEnumSetFilterComponent,
                        ActionCellRendererComponent,
                        RouterLinkRendererComponent,
                        SwitchRendererComponent,
                        CheckboxRendererComponent,
                        AgGridModule,
                        IconButtonsRendererComponent,
                        InlineEditDeleteRendererComponent,
                        NumericEditorComponent,
                        BooleanEditorComponent,
                        DatePickerEditorComponent,
                        NgSelectEditorComponent
                    ],
                    providers: [
                        GridFormatterService,
                        DatePickerHelperService,
                        DatePipe,
                        CurrencyPipe
                    ]
                }]
        }] });

class BaseAgGridDatasource {
    constructor(serviceCall, gridOptions, searchSpec, router, http = null, sortConversion = null, rowModelType = 'serverSide', includesTotalRecordsWithDataForServiceCall = false) {
        this.serviceCall = serviceCall;
        this.gridOptions = gridOptions;
        this.searchSpec = searchSpec;
        this.router = router;
        this.http = http;
        this.sortConversion = sortConversion;
        this.rowModelType = rowModelType;
        this.includesTotalRecordsWithDataForServiceCall = includesTotalRecordsWithDataForServiceCall;
        this.subscriptions = new Subscription();
        this.errorLoadingData = new EventEmitter();
        this.successfulLoadingData = new EventEmitter();
        this.startRow = 0;
        this.endRow = 0;
        this._numberOfItemsToReturn = 100;
        if (this.searchSpec == null || this.searchSpec == undefined) {
            this.searchSpec = {};
        }
        this.router.events.pipe(filter(e => e instanceof NavigationStart)).subscribe((routerEvent) => {
            this.subscriptions.unsubscribe();
        });
        if (this.searchSpec.pageSize && this.searchSpec.pageSize > 0) {
            this.endRow = this.searchSpec.pageSize;
        }
    }
    getRowsInit() {
        this.gridOptions.api.showLoadingOverlay();
        if (this.endRow && this.startRow) {
            this._numberOfItemsToReturn = this.endRow - this.startRow;
        }
        //Set the paging parameters
        if (!this.searchSpec.pageSize || this.searchSpec.pageSize <= 0) {
            this.searchSpec.pageSize = this._numberOfItemsToReturn;
        }
        this.searchSpec.currentIndex = this.startRow;
    }
    updateSorting(sortModel) {
        this.searchSpec.ordering = [];
        if (sortModel && sortModel.length > 0) {
            for (let x = 0; x < sortModel.length; x++) {
                this.searchSpec.ordering.push({
                    ascending: sortModel[x].sort == "asc",
                    fieldToSortBy: this.sortConversion != null ? this.sortConversion(sortModel[x].colId) : sortModel[x].colId,
                    sortOrder: x
                });
            }
        }
    }
    updateFilters(filterModel) {
        if (filterModel != null && filterModel != undefined) {
            if (this.searchSpec.filters == null)
                this.searchSpec.filters = filterModel;
            else {
                //Copy over any new filters supplied by the grid
                Object.keys(filterModel).forEach(property => this.searchSpec.filters[property] = filterModel[property]);
                let keysToRemove = [];
                for (let x = 0; x < Object.keys(this.searchSpec.filters).length; x++) {
                    let keyValue = Object.keys(this.searchSpec.filters)[x];
                    let newRequestDoesntHaveFilter = Object.keys(filterModel).filter(a => a == keyValue).length <= 0;
                    let oldRequestFilterDidntComeFromGrid = Object.keys(this.searchSpec.filters[keyValue]).filter(a => a == "notGridSupplied").length <= 0;
                    //Create list of old filter values with no value in new request that aren't ones we set externally
                    if (newRequestDoesntHaveFilter && oldRequestFilterDidntComeFromGrid)
                        keysToRemove.push(keyValue);
                }
                //Go through and clear out old grid set filters that aren't in new parameters
                for (let x = 0; x < keysToRemove.length; x++) {
                    delete this.searchSpec.filters[keysToRemove[x]];
                }
            }
        }
    }
    executeServiceCall(params) {
        let serverSideParams;
        let getRowsParams;
        if (this.rowModelType == 'serverSide') {
            serverSideParams = params;
        }
        else {
            getRowsParams = params;
        }
        let serviceCall$ = this.serviceCall(this.searchSpec, this.http).pipe(finalize(() => {
            this.subscriptions.add(serviceCall$);
        })).subscribe((data) => {
            let lastRow = -1;
            if (data.length < this.searchSpec.pageSize) {
                lastRow = this.startRow + data.length;
            }
            if (this.rowModelType == 'serverSide') {
                serverSideParams.success({ rowData: data, rowCount: lastRow });
            }
            else {
                getRowsParams.successCallback(data, lastRow);
            }
            this.gridOptions.api.sizeColumnsToFit();
            this.gridOptions.api.hideOverlay();
            this.successfulLoadingData.emit({ totalRecords: data.length });
        }, (error) => {
            if (this.rowModelType == 'serverSide') {
                serverSideParams.fail();
            }
            else {
                getRowsParams.failCallback();
            }
            console.log(error);
            this.errorLoadingData.emit(error);
        });
    }
    destroy() {
        this.subscriptions.unsubscribe();
    }
}

4;
class AgGridServerSideDataSource extends BaseAgGridDatasource {
    constructor(serviceCall, gridOptions, searchSpec, router, http = null, sortConversion = null, rowModelType = 'serverSide', includesTotalRecordsWithDataForServiceCall = false) {
        super(serviceCall, gridOptions, searchSpec, router, http, sortConversion, rowModelType, includesTotalRecordsWithDataForServiceCall);
    }
    getRows(params) {
        this.gridOptions.api.showLoadingOverlay();
        this.startRow = params.request.startRow;
        this.endRow = params.request.endRow;
        this.getRowsInit();
        this.updateFilters(params.request.filterModel);
        this.updateSorting(params.request.sortModel);
        this.executeServiceCall(params);
    }
    updateSearchParams(searchSpec) {
        this.searchSpec = searchSpec;
        this.gridOptions.api.refreshServerSide();
    }
    executeServiceCall(params) {
        let serverSideParams = params;
        if (this.includesTotalRecordsWithDataForServiceCall) {
            let serviceCall$ = this.serviceCall(this.searchSpec, this.http).pipe(finalize(() => {
                this.subscriptions.add(serviceCall$);
            })).subscribe((result) => {
                let lastRow = -1;
                if (result.data.length < this.searchSpec.pageSize) {
                    lastRow = this.startRow + result.data.length;
                }
                serverSideParams.success({ rowData: result.data, rowCount: lastRow });
                this.gridOptions.api.sizeColumnsToFit();
                this.gridOptions.api.hideOverlay();
                this.successfulLoadingData.emit({ totalRecords: result.totalRecords, recordsFromServiceCall: result.data.length });
            }, (error) => {
                serverSideParams.fail();
                console.log(error);
                this.errorLoadingData.emit(error);
            });
        }
        else {
            super.executeServiceCall(params);
        }
    }
}

class AgGridInfiniteDataSource extends BaseAgGridDatasource {
    constructor(serviceCall, gridOptions, searchSpec, router, http = null, sortConversion = null, rowModelType = 'infinite', includesTotalRecordsWithDataForServiceCall = false) {
        super(serviceCall, gridOptions, searchSpec, router, http, sortConversion, rowModelType, includesTotalRecordsWithDataForServiceCall);
    }
    getRows(params) {
        this.startRow = params.startRow;
        this.endRow = params.endRow;
        this.getRowsInit();
        this.updateFilters(params.filterModel);
        this.updateSorting(params.sortModel);
        this.executeServiceCall(params);
    }
    updateSearchParams(searchSpec) {
        this.searchSpec = searchSpec;
        this.gridOptions.api.refreshInfiniteCache();
    }
}

class OrderParameter {
    constructor() {
        this.fieldToSortBy = "";
        this.ascending = false;
        this.sortOrder = 0;
    }
}
class BaseSearch {
    constructor() {
        this.ordering = [];
        this.currentIndex = 0;
        this.pageSize = 100;
    }
}

class InlineEditDeleteButton {
}

class EnumSetFilterValue {
    constructor() {
        this.selected = true;
    }
}

class DataWithTotalRecordsResult {
    constructor() {
        this.data = [];
        this.totalRecords = 0;
    }
}

/*
 * Public API Surface of ag-grid-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ActionCellRendererComponent, AgGridBooleanFilterComponent, AgGridEnumSetFilterComponent, AgGridInfiniteDataSource, AgGridLibraryModule, AgGridServerSideDataSource, BaseSearch, BooleanEditorComponent, CheckboxRendererComponent, DataWithTotalRecordsResult, DatePickerEditorComponent, EnumSetFilterValue, GridFormatterService, IconButtonsRendererComponent, InlineEditDeleteButton, InlineEditDeleteButtonType, InlineEditDeleteRendererComponent, NgSelectEditorComponent, NumericEditorComponent, OrderParameter, RouterLinkRendererComponent, SVGIcon, SVGIconButton, SwitchRendererComponent, dateComparator, dateComparison, dateFilterComparator, parseDate };

